import { GameCard } from "./battle"

export interface CityHallPoint {
  id: string
  name: string
  latitude: number
  longitude: number
  radiusMeters: number
  cityId?: number
}

export interface CityHallSeasonEntry {
  rank: number
  userId: number
  nickname: string
  publicGameCode: string
  localPts: number
  globalPts: number
}

export interface CityHallStatus {
  cityId: number
  championFundCoins: number
  seasonMonthKey: string
  minPayoutCoins: number
  payoutShares: number[]
  seasonLeaderboard: CityHallSeasonEntry[]
  myLocalPts: number
  myGlobalPts: number
  cityHallPoint: CityHallPoint | null
}

/** Фаза городского рейда (атака своего города). */
export type CityHallRaidPhase = "VOTE" | "COMMIT" | "RESOLVED" | "CANCELLED"

export type CityHallRaidOutcome = "WIN" | "LOSE" | "DRAW" | string

export type CityHallDefenseTier = "WEAK" | "MEDIUM" | "STRONG"

export interface CityHallRaidRewards {
  winCoins: number
  loseCoins: number
  winPts: number
  losePts: number
  winShardCommon: number
  mvpPts: number
}

export interface CityHallDefenseSlot {
  cardIds: string[]
  cards: GameCard[]
  power: number
}

export interface CityHallRaidPreview {
  attackers: number
  attackCards: number
  attackPower: number
  defenseCards: number
  defenseTier: CityHallDefenseTier | null
  defenseTierLabel: string
  hullPower: number
}

export interface CityHallRaidCombatCard {
  id?: string
  element?: string
  colorRank?: string
  level?: number
  basePower?: number
  style?: string
  title?: string
}

export interface CityHallRaidCombatRound {
  index: number
  text: string
  winnerSide?: "ATTACK" | "DEFENSE" | string | null
  delta?: number | null
  attackScoreAfter: number
  defenseScoreAfter: number
  attackerNickname?: string | null
  defenderNickname?: string | null
  attackCard?: CityHallRaidCombatCard | null
  defenseCard?: CityHallRaidCombatCard | null
}

export interface CityHallRaidCombatLog {
  rounds: CityHallRaidCombatRound[]
  outcome?: CityHallRaidOutcome | null
  mvpNickname?: string | null
  mvpDelta?: number | null
  attackScore?: number | null
  defenseScore?: number | null
}

export interface CityHallMyRaid {
  id: string
  phase: CityHallRaidPhase
  eventDate?: string | null
  voteEndsAt?: string | null
  commitEndsAt?: string | null
  targetCityId?: number | null
  targetCityTitle?: string | null
  myVotedCityId?: number | null
  attackerCount: number
  attackerCap: number
  joined: boolean
  myAttackCardIds: string[]
  myAttackCards: GameCard[]
  remoteFeeCoins?: number | null
  outcome?: CityHallRaidOutcome | null
  attackScore?: number | null
  defenseScore?: number | null
  mvpNickname?: string | null
  mvpDelta?: number | null
  preview?: CityHallRaidPreview | null
}

export interface CityHallIncomingRaid {
  id: string
  phase: CityHallRaidPhase
  attackerCityId?: number | null
  attackerCityTitle?: string | null
  attackerCount: number
  attackerCap: number
  preview?: CityHallRaidPreview | null
  outcome?: CityHallRaidOutcome | null
  attackScore?: number | null
  defenseScore?: number | null
  mvpNickname?: string | null
  mvpDelta?: number | null
}

export interface CityHallRaidStatus {
  isEventDay: boolean
  eventDate: string | null
  cityHallPoint: CityHallPoint | null
  defenseStreak: number
  hullPower: number
  myDefense: CityHallDefenseSlot
  myRaid: CityHallMyRaid | null
  incomingRaid: CityHallIncomingRaid | null
  preview: CityHallRaidPreview | null
  rewards: CityHallRaidRewards
  nextRaidLabel?: string | null
}

export interface CityHallRaidTarget {
  cityId: number
  title: string
  onCooldown: boolean
  defenseStreak: number
  hullPower: number
  defenseCards: number
  defenseTier: CityHallDefenseTier | null
  defenseTierLabel: string
}

export interface CityHallRaidDetail {
  id: string
  phase: CityHallRaidPhase
  outcome?: CityHallRaidOutcome | null
  attackScore?: number | null
  defenseScore?: number | null
  mvpNickname?: string | null
  mvpDelta?: number | null
  combatLog: CityHallRaidCombatLog | null
  preview?: CityHallRaidPreview | null
  attackerCityTitle?: string | null
  defenderCityTitle?: string | null
  status?: CityHallRaidStatus | null
}

export interface CityHallRaidGeoBody {
  cardIds: string[]
  latitude?: number | null
  longitude?: number | null
}

/** Дефолтные награды для тултипов, если API не прислал. */
export const DEFAULT_CITY_HALL_RAID_REWARDS: CityHallRaidRewards = {
  winCoins: 2000,
  loseCoins: 50,
  winPts: 100,
  losePts: 10,
  winShardCommon: 1,
  mvpPts: 50,
}

export const CITY_HALL_RAID_CARD_MAX = 3
export const CITY_HALL_RAID_ATTACKER_CAP_DEFAULT = 10
export const CITY_HALL_RAID_REMOTE_FEE_DEFAULT = 100
